var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-textarea", class: _vm.computedClass },
    [
      _c(
        "div",
        { staticClass: "textarea-render", style: { height: _vm.height } },
        [
          _c("textarea", {
            staticClass: "component-inner-textarea w-normal",
            attrs: { placeholder: _vm.placeholder, disabled: _vm.disabled },
            domProps: { value: _vm.value },
            on: { input: _vm.handleInput, blur: _vm.handleBlur }
          })
        ]
      ),
      _c("div", { staticClass: "info-render" }, [
        _vm.showMsg
          ? _c("div", { staticClass: "err-msg" }, [_vm._v(_vm._s(_vm.msg))])
          : _vm._e(),
        _vm.counter
          ? _c(
              "div",
              { staticClass: "count-info w-normal" },
              [
                _vm._v(" " + _vm._s(_vm.wordsLength)),
                _vm.maxCount ? [_vm._v("/" + _vm._s(_vm.maxCount))] : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }